import React from 'react';

import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';

import { PromoInfoBox } from 'entities/Promo/ui/PromoInfoBox/PromoInfoBox';
import { ToFullDealAdvertisingButton } from 'features/FullDeal';

interface Props {
  link: string;
  buttonColor?: ButtonProps['color'];
  className?: string;
  source: string;
}

export const PromoDealRedirectToAppButton = ({ link, buttonColor, source, ...other }: Props) => (
  <PromoInfoBox>
    <ToFullDealAdvertisingButton
      {...other}
      style={{ width: '100%', color: '#fff', backgroundColor: `var(--adengi-accent-primary)` }}
      size={52}
      block
      variant="primary"
      link={link}
      color={buttonColor}
      source={source}
    >
      Получить займ в приложении
    </ToFullDealAdvertisingButton>
  </PromoInfoBox>
);
